import { BroadcastMessage } from '@map/core';
import { DeviceAuthenticatorModule } from './DeviceAuthenticatorModule';
import { BindingType } from './BindingType';

export class BindingsChangedMessage extends BroadcastMessage {
  readonly tag: string = DeviceAuthenticatorModule.bindingsChangedMessageTag;

  bindingType!: BindingType;
}